module.exports = __webpack_public_path__ + "img/pota-video-cover.059a9f70.jpg";